
import { macroCondition, getGlobalConfig } from '@embroider/macros';


import defineModule0 from "./-embroider-implicit-modules.js";

import * as amdModule0 from "./adapters/application.ts"
import * as amdModule1 from "./adapters/enrolments/application.ts"
import * as amdModule2 from "./adapters/enrolments/base.ts"
import * as amdModule3 from "./adapters/enrolments/schema.ts"
import * as amdModule4 from "./adapters/people-schema/base.ts"
import * as amdModule5 from "./adapters/people-schema/field.ts"
import * as amdModule6 from "./adapters/people-schema/group.ts"
import * as amdModule7 from "./config/environment.ts"
import * as amdModule8 from "./deprecation-workflow.js"
import * as amdModule9 from "./initializers/oauth2.ts"
import * as amdModule10 from "./models/enrolments/application.ts"
import * as amdModule11 from "./models/enrolments/contact.ts"
import * as amdModule12 from "./router.ts"
import * as amdModule13 from "./serializers/application.js"
import * as amdModule14 from "./serializers/enrolments/application.js"
import * as amdModule15 from "./serializers/enrolments/base.js"
import * as amdModule16 from "./serializers/enrolments/contact.js"
import * as amdModule17 from "./serializers/enrolments/medical-condition.js"
import * as amdModule18 from "./serializers/enrolments/schema.js"
import * as amdModule19 from "./serializers/people-schema/base.js"
import * as amdModule20 from "./serializers/people-schema/field.js"
import * as amdModule21 from "./services/store.js"
import * as amdModule22 from "./initializers/viewport-config.js"
import * as amdModule23 from "./services/in-viewport.js"
import * as amdModule24 from "./services/-ensure-registered.js"
import * as amdModule25 from "./services/constants.js"
import * as amdModule26 from "./services/paper-sidenav.js"
import * as amdModule27 from "./services/paper-theme.js"
import * as amdModule28 from "./services/paper-toaster.js"
import * as amdModule29 from "./services/sniffer.js"
import * as amdModule30 from "./utils/clamp.js"
import * as amdModule31 from "./transforms/array.js"
import * as amdModule32 from "./transforms/fragment-array.js"
import * as amdModule33 from "./transforms/fragment.js"
import * as amdModule34 from "./initializers/ember-data.js"
import * as amdModule35 from "./transforms/date.js"
import * as amdModule36 from "./transforms/number.js"
import * as amdModule37 from "./transforms/string.js"
import * as amdModule38 from "./transforms/boolean.js"
import * as amdModule39 from "./data-adapter.js"
import * as amdModule40 from "./adapters/base.js"
import * as amdModule41 from "./adapters/device.js"
import * as amdModule42 from "./adapters/group.js"
import * as amdModule43 from "./adapters/person.js"
import * as amdModule44 from "./adapters/policy.js"
import * as amdModule45 from "./adapters/school.js"
import * as amdModule46 from "./adapters/user.js"
import * as amdModule47 from "./initializers/fragment-array-iterable.js"
import * as amdModule48 from "./initializers/fragment-array-mutable.js"
import * as amdModule49 from "./initializers/query-params-helper.js"
import * as amdModule50 from "./instance-initializers/faro.js"
import * as amdModule51 from "./models/address.js"
import * as amdModule52 from "./models/assessments/assessment.js"
import * as amdModule53 from "./models/assessments/category.js"
import * as amdModule54 from "./models/assessments/grade-schedule.js"
import * as amdModule55 from "./models/assessments/grade.js"
import * as amdModule56 from "./models/assessments/gradeschedule-numeric.js"
import * as amdModule57 from "./models/assessments/gradeschedule-range.js"
import * as amdModule58 from "./models/assessments/gradeschedule-select.js"
import * as amdModule59 from "./models/assessments/gradeschedule-selectvalue.js"
import * as amdModule60 from "./models/assessments/module.js"
import * as amdModule61 from "./models/attendance/nz-moe-day.js"
import * as amdModule62 from "./models/auth/qr-code.js"
import * as amdModule63 from "./models/autogroup-params.js"
import * as amdModule64 from "./models/bookings/allocation.js"
import * as amdModule65 from "./models/bookings/booking.js"
import * as amdModule66 from "./models/bookings/date.js"
import * as amdModule67 from "./models/bookings/event.js"
import * as amdModule68 from "./models/bookings/reservation.js"
import * as amdModule69 from "./models/bookings/session.js"
import * as amdModule70 from "./models/bookings/slot.js"
import * as amdModule71 from "./models/bookings/teacher-group-mapping.js"
import * as amdModule72 from "./models/cron/process-monitor-error.js"
import * as amdModule73 from "./models/cron/process-monitor.js"
import * as amdModule74 from "./models/cron/progress.js"
import * as amdModule75 from "./models/device.js"
import * as amdModule76 from "./models/dynamic-field/value-list-item.js"
import * as amdModule77 from "./models/dynamic-field/value.js"
import * as amdModule78 from "./models/dynamic-field/values.js"
import * as amdModule79 from "./models/enrolments/field.js"
import * as amdModule80 from "./models/enrolments/medical-condition.js"
import * as amdModule81 from "./models/enrolments/schema.js"
import * as amdModule82 from "./models/enrolments/section.js"
import * as amdModule83 from "./models/events/cost-mapping-option.js"
import * as amdModule84 from "./models/events/cost-mapping.js"
import * as amdModule85 from "./models/events/event-count.js"
import * as amdModule86 from "./models/events/event.js"
import * as amdModule87 from "./models/events/mitigation.js"
import * as amdModule88 from "./models/events/option-count.js"
import * as amdModule89 from "./models/events/option-limit.js"
import * as amdModule90 from "./models/events/permission-reply.js"
import * as amdModule91 from "./models/events/permission.js"
import * as amdModule92 from "./models/events/risk.js"
import * as amdModule93 from "./models/events/template.js"
import * as amdModule94 from "./models/events/value-limit.js"
import * as amdModule95 from "./models/finance/account.js"
import * as amdModule96 from "./models/finance/line-item.js"
import * as amdModule97 from "./models/goals/badge-assertion.js"
import * as amdModule98 from "./models/goals/badge-badge.js"
import * as amdModule99 from "./models/goals/badge-criteria.js"
import * as amdModule100 from "./models/goals/badge-profile.js"
import * as amdModule101 from "./models/goals/badge-recipient.js"
import * as amdModule102 from "./models/goals/badge-verification.js"
import * as amdModule103 from "./models/goals/badge.js"
import * as amdModule104 from "./models/goals/category.js"
import * as amdModule105 from "./models/goals/goal.js"
import * as amdModule106 from "./models/goals/state.js"
import * as amdModule107 from "./models/goals/subcategory.js"
import * as amdModule108 from "./models/goals/subject.js"
import * as amdModule109 from "./models/group.js"
import * as amdModule110 from "./models/groups/member.js"
import * as amdModule111 from "./models/media.js"
import * as amdModule112 from "./models/media/image.js"
import * as amdModule113 from "./models/media/rendition.js"
import * as amdModule114 from "./models/media/video.js"
import * as amdModule115 from "./models/milestones/expectation.js"
import * as amdModule116 from "./models/milestones/level.js"
import * as amdModule117 from "./models/milestones/milestone-set.js"
import * as amdModule118 from "./models/milestones/milestone.js"
import * as amdModule119 from "./models/milestones/progression.js"
import * as amdModule120 from "./models/notifications/notification.js"
import * as amdModule121 from "./models/people-schema/field-option.js"
import * as amdModule122 from "./models/people-schema/field.js"
import * as amdModule123 from "./models/people-schema/group.js"
import * as amdModule124 from "./models/people/caregiver.js"
import * as amdModule125 from "./models/people/learner.js"
import * as amdModule126 from "./models/people/medical.js"
import * as amdModule127 from "./models/people/options.js"
import * as amdModule128 from "./models/people/policy-acceptance.js"
import * as amdModule129 from "./models/people/post-count-assessment.js"
import * as amdModule130 from "./models/people/post-count-base.js"
import * as amdModule131 from "./models/people/post-count-goal.js"
import * as amdModule132 from "./models/people/post-count-page.js"
import * as amdModule133 from "./models/people/post-counts.js"
import * as amdModule134 from "./models/people/staff.js"
import * as amdModule135 from "./models/person.js"
import * as amdModule136 from "./models/policy.js"
import * as amdModule137 from "./models/posts/attendancenote.js"
import * as amdModule138 from "./models/posts/comment.js"
import * as amdModule139 from "./models/posts/feed-entry.js"
import * as amdModule140 from "./models/posts/globalnotice.js"
import * as amdModule141 from "./models/posts/member.js"
import * as amdModule142 from "./models/posts/page-set.js"
import * as amdModule143 from "./models/posts/page.js"
import * as amdModule144 from "./models/posts/post-template.js"
import * as amdModule145 from "./models/posts/post.js"
import * as amdModule146 from "./models/posts/reaction.js"
import * as amdModule147 from "./models/posts/tag-category.js"
import * as amdModule148 from "./models/posts/tag.js"
import * as amdModule149 from "./models/reports/report-feedback.js"
import * as amdModule150 from "./models/reports/report-judgement-wording.js"
import * as amdModule151 from "./models/reports/report-template-period.js"
import * as amdModule152 from "./models/reports/report-template-section.js"
import * as amdModule153 from "./models/reports/report-template.js"
import * as amdModule154 from "./models/reports/rubric-column.js"
import * as amdModule155 from "./models/reports/rubric-criteria.js"
import * as amdModule156 from "./models/reports/rubric-element.js"
import * as amdModule157 from "./models/reports/rubric-family.js"
import * as amdModule158 from "./models/reports/rubric-state.js"
import * as amdModule159 from "./models/reports/rubric.js"
import * as amdModule160 from "./models/reports/student-report-section-element.js"
import * as amdModule161 from "./models/reports/student-report-section.js"
import * as amdModule162 from "./models/reports/student-report.js"
import * as amdModule163 from "./models/school-options/field.js"
import * as amdModule164 from "./models/school-options/group.js"
import * as amdModule165 from "./models/school-options/heading.js"
import * as amdModule166 from "./models/school.js"
import * as amdModule167 from "./models/schools/location.js"
import * as amdModule168 from "./models/sif/au/connection.js"
import * as amdModule169 from "./models/sif/au/zone.js"
import * as amdModule170 from "./models/snapshots/pdf-include.js"
import * as amdModule171 from "./models/snapshots/pdf.js"
import * as amdModule172 from "./models/snapshots/snapshot-set.js"
import * as amdModule173 from "./models/snapshots/snapshot.js"
import * as amdModule174 from "./models/surveys/response.js"
import * as amdModule175 from "./models/surveys/survey.js"
import * as amdModule176 from "./models/term.js"
import * as amdModule177 from "./models/timeframe.js"
import * as amdModule178 from "./models/timetable/day.js"
import * as amdModule179 from "./models/timetable/period.js"
import * as amdModule180 from "./models/timetable/structure.js"
import * as amdModule181 from "./models/user.js"
import * as amdModule182 from "./models/wonde/address.js"
import * as amdModule183 from "./models/wonde/connection.js"
import * as amdModule184 from "./models/wonde/school.js"
import * as amdModule185 from "./serializers/address.js"
import * as amdModule186 from "./serializers/auth/base.js"
import * as amdModule187 from "./serializers/auth/qr-code.js"
import * as amdModule188 from "./serializers/bookings/allocation.js"
import * as amdModule189 from "./serializers/bookings/base.js"
import * as amdModule190 from "./serializers/bookings/booking.js"
import * as amdModule191 from "./serializers/bookings/event.js"
import * as amdModule192 from "./serializers/bookings/slot.js"
import * as amdModule193 from "./serializers/cron/process-monitor.js"
import * as amdModule194 from "./serializers/dynamic-field/value.js"
import * as amdModule195 from "./serializers/events/base.js"
import * as amdModule196 from "./serializers/events/cost-mapping-option.js"
import * as amdModule197 from "./serializers/events/cost-mapping.js"
import * as amdModule198 from "./serializers/events/event-count.js"
import * as amdModule199 from "./serializers/events/event.js"
import * as amdModule200 from "./serializers/events/mitigation.js"
import * as amdModule201 from "./serializers/events/permission-reply.js"
import * as amdModule202 from "./serializers/events/permission.js"
import * as amdModule203 from "./serializers/events/risk.js"
import * as amdModule204 from "./serializers/events/template.js"
import * as amdModule205 from "./serializers/goals/badge.js"
import * as amdModule206 from "./serializers/goals/base.js"
import * as amdModule207 from "./serializers/goals/category.js"
import * as amdModule208 from "./serializers/goals/goal.js"
import * as amdModule209 from "./serializers/goals/state.js"
import * as amdModule210 from "./serializers/goals/subcategory.js"
import * as amdModule211 from "./serializers/goals/subject.js"
import * as amdModule212 from "./serializers/media.js"
import * as amdModule213 from "./serializers/milestones/base.js"
import * as amdModule214 from "./serializers/milestones/expectation.js"
import * as amdModule215 from "./serializers/milestones/level.js"
import * as amdModule216 from "./serializers/milestones/milestone-set.js"
import * as amdModule217 from "./serializers/milestones/milestone.js"
import * as amdModule218 from "./serializers/milestones/progression.js"
import * as amdModule219 from "./serializers/person.js"
import * as amdModule220 from "./serializers/posts/attendancenote.js"
import * as amdModule221 from "./serializers/posts/base.js"
import * as amdModule222 from "./serializers/posts/comment.js"
import * as amdModule223 from "./serializers/posts/feed-entry.js"
import * as amdModule224 from "./serializers/posts/globalnotice.js"
import * as amdModule225 from "./serializers/posts/page-set.js"
import * as amdModule226 from "./serializers/posts/page.js"
import * as amdModule227 from "./serializers/posts/post-template.js"
import * as amdModule228 from "./serializers/posts/post.js"
import * as amdModule229 from "./serializers/posts/reaction.js"
import * as amdModule230 from "./serializers/posts/tag-category.js"
import * as amdModule231 from "./serializers/posts/tag.js"
import * as amdModule232 from "./serializers/reports/base.js"
import * as amdModule233 from "./serializers/reports/report-feedback.js"
import * as amdModule234 from "./serializers/reports/report-template-section.js"
import * as amdModule235 from "./serializers/reports/report-template.js"
import * as amdModule236 from "./serializers/reports/rubric-criteria.js"
import * as amdModule237 from "./serializers/reports/rubric-element.js"
import * as amdModule238 from "./serializers/reports/rubric-family.js"
import * as amdModule239 from "./serializers/reports/rubric-state.js"
import * as amdModule240 from "./serializers/reports/rubric.js"
import * as amdModule241 from "./serializers/reports/student-report-section.js"
import * as amdModule242 from "./serializers/reports/student-report.js"
import * as amdModule243 from "./serializers/school-options/field.js"
import * as amdModule244 from "./serializers/school-options/group.js"
import * as amdModule245 from "./serializers/school-options/heading.js"
import * as amdModule246 from "./serializers/school.js"
import * as amdModule247 from "./serializers/sif/au/base.js"
import * as amdModule248 from "./serializers/sif/au/connection.js"
import * as amdModule249 from "./serializers/sif/au/zone.js"
import * as amdModule250 from "./serializers/surveys/base.js"
import * as amdModule251 from "./serializers/surveys/response.js"
import * as amdModule252 from "./serializers/surveys/survey.js"
import * as amdModule253 from "./serializers/timetable/base.js"
import * as amdModule254 from "./serializers/timetable/period.js"
import * as amdModule255 from "./serializers/timetable/structure.js"
import * as amdModule256 from "./serializers/user.js"
import * as amdModule257 from "./serializers/wonde/connection.js"
import * as amdModule258 from "./serializers/wonde/school.js"
import * as amdModule259 from "./services/colours.js"
import * as amdModule260 from "./services/dates.js"
import * as amdModule261 from "./services/environment.js"
import * as amdModule262 from "./services/faro.js"
import * as amdModule263 from "./services/fetch.js"
import * as amdModule264 from "./services/field-options.js"
import * as amdModule265 from "./services/google-drive.js"
import * as amdModule266 from "./services/group-years.js"
import * as amdModule267 from "./services/hero-api-auth.js"
import * as amdModule268 from "./services/hero-api-bookings-allocations.js"
import * as amdModule269 from "./services/hero-api-bookings.js"
import * as amdModule270 from "./services/hero-api-comments.js"
import * as amdModule271 from "./services/hero-api-goals.js"
import * as amdModule272 from "./services/hero-api-people.js"
import * as amdModule273 from "./services/hero-api.js"
import * as amdModule274 from "./services/logging.js"
import * as amdModule275 from "./services/media.js"
import * as amdModule276 from "./services/notifications.js"
import * as amdModule277 from "./services/options.js"
import * as amdModule278 from "./services/permissions.js"
import * as amdModule279 from "./services/person-options.js"
import * as amdModule280 from "./services/policy-acceptance.js"
import * as amdModule281 from "./services/print.js"
import * as amdModule282 from "./services/push-notifications.js"
import * as amdModule283 from "./services/roles.js"
import * as amdModule284 from "./services/session.js"
import * as amdModule285 from "./services/strings.js"
import * as amdModule286 from "./services/tax.js"
import * as amdModule287 from "./services/terms.js"
import * as amdModule288 from "./services/toaster.js"
import * as amdModule289 from "./services/uppy.js"
import * as amdModule290 from "./transforms/json.js"
import * as amdModule291 from "./utils/auditing.js"
import * as amdModule292 from "./utils/chunk.js"
import * as amdModule293 from "./utils/colour.js"
import * as amdModule294 from "./utils/d3-tip.js"
import * as amdModule295 from "./utils/dynamic-field-types.js"
import * as amdModule296 from "./utils/fields.js"
import * as amdModule297 from "./utils/filtering.js"
import * as amdModule298 from "./utils/grades.js"
import * as amdModule299 from "./utils/long-tasks.js"
import * as amdModule300 from "./utils/map-with-concurrency.js"
import * as amdModule301 from "./utils/oauth2.js"
import * as amdModule302 from "./utils/options.js"
import * as amdModule303 from "./utils/platform.js"
import * as amdModule304 from "./utils/post-templates.js"
import * as amdModule305 from "./utils/progressions.js"
import * as amdModule306 from "./utils/pronouns.js"
import * as amdModule307 from "./utils/reports.js"
import * as amdModule308 from "./utils/school-date.js"
import * as amdModule309 from "./utils/snapshots.js"
import * as amdModule310 from "./utils/stationery.js"
import * as amdModule311 from "./utils/strings.js"
import * as amdModule312 from "./utils/table.js"
import * as amdModule313 from "./utils/tags.js"
import * as amdModule314 from "./utils/tinymce.js"
import * as amdModule315 from "./utils/topic-steps.js"
import * as amdModule316 from "./services/page-title.js"
import * as amdModule317 from "./services/drag-sort.js"
import * as amdModule318 from "./templates/apply-complete.hbs"
import * as amdModule319 from "./controllers/apply-complete.js"
import * as amdModule320 from "./routes/apply-complete.ts"
import * as amdModule321 from "./templates/apply.hbs"
import * as amdModule322 from "./controllers/apply.js"
import * as amdModule323 from "./routes/apply.js"
import * as amdModule324 from "./templates/error.hbs"
import * as amdModule325 from "./controllers/error.ts"
import * as amdModule326 from "./routes/base.ts"
import * as amdModule327 from "./templates/school-not-found.hbs"
import * as amdModule328 from "./routes/school-not-found.ts"
import * as amdModule329 from "./templates/application.hbs"
import * as amdModule330 from "./templates/loading.hbs"
import * as amdModule331 from "./templates/logged-out.js"
import * as amdModule332 from "./controllers/logged-out.js"
import * as amdModule333 from "./routes/logged-out.js"
import * as amdModule334 from "./templates/login-failed.js"
import * as amdModule335 from "./controllers/login-failed.js"
import * as amdModule336 from "./routes/login-failed.js"
import * as amdModule337 from "./templates/school-switching.js"
import * as amdModule338 from "./controllers/school-switching.js"
import * as amdModule339 from "./routes/school-switching.js"
import * as amdModule340 from "./templates/callback.js"
import * as amdModule341 from "./routes/callback.js"
import * as amdModule342 from "./routes/login.js"
import * as amdModule343 from "./templates/logout.js"
import * as amdModule344 from "./routes/logout.js"
import * as amdModule345 from "./routes/springboard.js"
import * as amdModule346 from "./routes/startup.js"
import * as amdModule347 from "./templates/not-found.js"

let exportFastbootModules = {};





export default Object.assign(
  {},
defineModule0,
  {
"linced-enrolments/adapters/application": amdModule0,
"linced-enrolments/adapters/enrolments/application": amdModule1,
"linced-enrolments/adapters/enrolments/base": amdModule2,
"linced-enrolments/adapters/enrolments/schema": amdModule3,
"linced-enrolments/adapters/people-schema/base": amdModule4,
"linced-enrolments/adapters/people-schema/field": amdModule5,
"linced-enrolments/adapters/people-schema/group": amdModule6,
"linced-enrolments/config/environment": amdModule7,
"linced-enrolments/deprecation-workflow": amdModule8,
"linced-enrolments/initializers/oauth2": amdModule9,
"linced-enrolments/models/enrolments/application": amdModule10,
"linced-enrolments/models/enrolments/contact": amdModule11,
"linced-enrolments/router": amdModule12,
"linced-enrolments/serializers/application": amdModule13,
"linced-enrolments/serializers/enrolments/application": amdModule14,
"linced-enrolments/serializers/enrolments/base": amdModule15,
"linced-enrolments/serializers/enrolments/contact": amdModule16,
"linced-enrolments/serializers/enrolments/medical-condition": amdModule17,
"linced-enrolments/serializers/enrolments/schema": amdModule18,
"linced-enrolments/serializers/people-schema/base": amdModule19,
"linced-enrolments/serializers/people-schema/field": amdModule20,
"linced-enrolments/services/store": amdModule21,
"linced-enrolments/initializers/viewport-config": amdModule22,
"linced-enrolments/services/in-viewport": amdModule23,
"linced-enrolments/services/-ensure-registered": amdModule24,
"linced-enrolments/services/constants": amdModule25,
"linced-enrolments/services/paper-sidenav": amdModule26,
"linced-enrolments/services/paper-theme": amdModule27,
"linced-enrolments/services/paper-toaster": amdModule28,
"linced-enrolments/services/sniffer": amdModule29,
"linced-enrolments/utils/clamp": amdModule30,
"linced-enrolments/transforms/array": amdModule31,
"linced-enrolments/transforms/fragment-array": amdModule32,
"linced-enrolments/transforms/fragment": amdModule33,
"linced-enrolments/initializers/ember-data": amdModule34,
"linced-enrolments/transforms/date": amdModule35,
"linced-enrolments/transforms/number": amdModule36,
"linced-enrolments/transforms/string": amdModule37,
"linced-enrolments/transforms/boolean": amdModule38,
"linced-enrolments/data-adapter": amdModule39,
"linced-enrolments/adapters/base": amdModule40,
"linced-enrolments/adapters/device": amdModule41,
"linced-enrolments/adapters/group": amdModule42,
"linced-enrolments/adapters/person": amdModule43,
"linced-enrolments/adapters/policy": amdModule44,
"linced-enrolments/adapters/school": amdModule45,
"linced-enrolments/adapters/user": amdModule46,
"linced-enrolments/initializers/fragment-array-iterable": amdModule47,
"linced-enrolments/initializers/fragment-array-mutable": amdModule48,
"linced-enrolments/initializers/query-params-helper": amdModule49,
"linced-enrolments/instance-initializers/faro": amdModule50,
"linced-enrolments/models/address": amdModule51,
"linced-enrolments/models/assessments/assessment": amdModule52,
"linced-enrolments/models/assessments/category": amdModule53,
"linced-enrolments/models/assessments/grade-schedule": amdModule54,
"linced-enrolments/models/assessments/grade": amdModule55,
"linced-enrolments/models/assessments/gradeschedule-numeric": amdModule56,
"linced-enrolments/models/assessments/gradeschedule-range": amdModule57,
"linced-enrolments/models/assessments/gradeschedule-select": amdModule58,
"linced-enrolments/models/assessments/gradeschedule-selectvalue": amdModule59,
"linced-enrolments/models/assessments/module": amdModule60,
"linced-enrolments/models/attendance/nz-moe-day": amdModule61,
"linced-enrolments/models/auth/qr-code": amdModule62,
"linced-enrolments/models/autogroup-params": amdModule63,
"linced-enrolments/models/bookings/allocation": amdModule64,
"linced-enrolments/models/bookings/booking": amdModule65,
"linced-enrolments/models/bookings/date": amdModule66,
"linced-enrolments/models/bookings/event": amdModule67,
"linced-enrolments/models/bookings/reservation": amdModule68,
"linced-enrolments/models/bookings/session": amdModule69,
"linced-enrolments/models/bookings/slot": amdModule70,
"linced-enrolments/models/bookings/teacher-group-mapping": amdModule71,
"linced-enrolments/models/cron/process-monitor-error": amdModule72,
"linced-enrolments/models/cron/process-monitor": amdModule73,
"linced-enrolments/models/cron/progress": amdModule74,
"linced-enrolments/models/device": amdModule75,
"linced-enrolments/models/dynamic-field/value-list-item": amdModule76,
"linced-enrolments/models/dynamic-field/value": amdModule77,
"linced-enrolments/models/dynamic-field/values": amdModule78,
"linced-enrolments/models/enrolments/field": amdModule79,
"linced-enrolments/models/enrolments/medical-condition": amdModule80,
"linced-enrolments/models/enrolments/schema": amdModule81,
"linced-enrolments/models/enrolments/section": amdModule82,
"linced-enrolments/models/events/cost-mapping-option": amdModule83,
"linced-enrolments/models/events/cost-mapping": amdModule84,
"linced-enrolments/models/events/event-count": amdModule85,
"linced-enrolments/models/events/event": amdModule86,
"linced-enrolments/models/events/mitigation": amdModule87,
"linced-enrolments/models/events/option-count": amdModule88,
"linced-enrolments/models/events/option-limit": amdModule89,
"linced-enrolments/models/events/permission-reply": amdModule90,
"linced-enrolments/models/events/permission": amdModule91,
"linced-enrolments/models/events/risk": amdModule92,
"linced-enrolments/models/events/template": amdModule93,
"linced-enrolments/models/events/value-limit": amdModule94,
"linced-enrolments/models/finance/account": amdModule95,
"linced-enrolments/models/finance/line-item": amdModule96,
"linced-enrolments/models/goals/badge-assertion": amdModule97,
"linced-enrolments/models/goals/badge-badge": amdModule98,
"linced-enrolments/models/goals/badge-criteria": amdModule99,
"linced-enrolments/models/goals/badge-profile": amdModule100,
"linced-enrolments/models/goals/badge-recipient": amdModule101,
"linced-enrolments/models/goals/badge-verification": amdModule102,
"linced-enrolments/models/goals/badge": amdModule103,
"linced-enrolments/models/goals/category": amdModule104,
"linced-enrolments/models/goals/goal": amdModule105,
"linced-enrolments/models/goals/state": amdModule106,
"linced-enrolments/models/goals/subcategory": amdModule107,
"linced-enrolments/models/goals/subject": amdModule108,
"linced-enrolments/models/group": amdModule109,
"linced-enrolments/models/groups/member": amdModule110,
"linced-enrolments/models/media": amdModule111,
"linced-enrolments/models/media/image": amdModule112,
"linced-enrolments/models/media/rendition": amdModule113,
"linced-enrolments/models/media/video": amdModule114,
"linced-enrolments/models/milestones/expectation": amdModule115,
"linced-enrolments/models/milestones/level": amdModule116,
"linced-enrolments/models/milestones/milestone-set": amdModule117,
"linced-enrolments/models/milestones/milestone": amdModule118,
"linced-enrolments/models/milestones/progression": amdModule119,
"linced-enrolments/models/notifications/notification": amdModule120,
"linced-enrolments/models/people-schema/field-option": amdModule121,
"linced-enrolments/models/people-schema/field": amdModule122,
"linced-enrolments/models/people-schema/group": amdModule123,
"linced-enrolments/models/people/caregiver": amdModule124,
"linced-enrolments/models/people/learner": amdModule125,
"linced-enrolments/models/people/medical": amdModule126,
"linced-enrolments/models/people/options": amdModule127,
"linced-enrolments/models/people/policy-acceptance": amdModule128,
"linced-enrolments/models/people/post-count-assessment": amdModule129,
"linced-enrolments/models/people/post-count-base": amdModule130,
"linced-enrolments/models/people/post-count-goal": amdModule131,
"linced-enrolments/models/people/post-count-page": amdModule132,
"linced-enrolments/models/people/post-counts": amdModule133,
"linced-enrolments/models/people/staff": amdModule134,
"linced-enrolments/models/person": amdModule135,
"linced-enrolments/models/policy": amdModule136,
"linced-enrolments/models/posts/attendancenote": amdModule137,
"linced-enrolments/models/posts/comment": amdModule138,
"linced-enrolments/models/posts/feed-entry": amdModule139,
"linced-enrolments/models/posts/globalnotice": amdModule140,
"linced-enrolments/models/posts/member": amdModule141,
"linced-enrolments/models/posts/page-set": amdModule142,
"linced-enrolments/models/posts/page": amdModule143,
"linced-enrolments/models/posts/post-template": amdModule144,
"linced-enrolments/models/posts/post": amdModule145,
"linced-enrolments/models/posts/reaction": amdModule146,
"linced-enrolments/models/posts/tag-category": amdModule147,
"linced-enrolments/models/posts/tag": amdModule148,
"linced-enrolments/models/reports/report-feedback": amdModule149,
"linced-enrolments/models/reports/report-judgement-wording": amdModule150,
"linced-enrolments/models/reports/report-template-period": amdModule151,
"linced-enrolments/models/reports/report-template-section": amdModule152,
"linced-enrolments/models/reports/report-template": amdModule153,
"linced-enrolments/models/reports/rubric-column": amdModule154,
"linced-enrolments/models/reports/rubric-criteria": amdModule155,
"linced-enrolments/models/reports/rubric-element": amdModule156,
"linced-enrolments/models/reports/rubric-family": amdModule157,
"linced-enrolments/models/reports/rubric-state": amdModule158,
"linced-enrolments/models/reports/rubric": amdModule159,
"linced-enrolments/models/reports/student-report-section-element": amdModule160,
"linced-enrolments/models/reports/student-report-section": amdModule161,
"linced-enrolments/models/reports/student-report": amdModule162,
"linced-enrolments/models/school-options/field": amdModule163,
"linced-enrolments/models/school-options/group": amdModule164,
"linced-enrolments/models/school-options/heading": amdModule165,
"linced-enrolments/models/school": amdModule166,
"linced-enrolments/models/schools/location": amdModule167,
"linced-enrolments/models/sif/au/connection": amdModule168,
"linced-enrolments/models/sif/au/zone": amdModule169,
"linced-enrolments/models/snapshots/pdf-include": amdModule170,
"linced-enrolments/models/snapshots/pdf": amdModule171,
"linced-enrolments/models/snapshots/snapshot-set": amdModule172,
"linced-enrolments/models/snapshots/snapshot": amdModule173,
"linced-enrolments/models/surveys/response": amdModule174,
"linced-enrolments/models/surveys/survey": amdModule175,
"linced-enrolments/models/term": amdModule176,
"linced-enrolments/models/timeframe": amdModule177,
"linced-enrolments/models/timetable/day": amdModule178,
"linced-enrolments/models/timetable/period": amdModule179,
"linced-enrolments/models/timetable/structure": amdModule180,
"linced-enrolments/models/user": amdModule181,
"linced-enrolments/models/wonde/address": amdModule182,
"linced-enrolments/models/wonde/connection": amdModule183,
"linced-enrolments/models/wonde/school": amdModule184,
"linced-enrolments/serializers/address": amdModule185,
"linced-enrolments/serializers/auth/base": amdModule186,
"linced-enrolments/serializers/auth/qr-code": amdModule187,
"linced-enrolments/serializers/bookings/allocation": amdModule188,
"linced-enrolments/serializers/bookings/base": amdModule189,
"linced-enrolments/serializers/bookings/booking": amdModule190,
"linced-enrolments/serializers/bookings/event": amdModule191,
"linced-enrolments/serializers/bookings/slot": amdModule192,
"linced-enrolments/serializers/cron/process-monitor": amdModule193,
"linced-enrolments/serializers/dynamic-field/value": amdModule194,
"linced-enrolments/serializers/events/base": amdModule195,
"linced-enrolments/serializers/events/cost-mapping-option": amdModule196,
"linced-enrolments/serializers/events/cost-mapping": amdModule197,
"linced-enrolments/serializers/events/event-count": amdModule198,
"linced-enrolments/serializers/events/event": amdModule199,
"linced-enrolments/serializers/events/mitigation": amdModule200,
"linced-enrolments/serializers/events/permission-reply": amdModule201,
"linced-enrolments/serializers/events/permission": amdModule202,
"linced-enrolments/serializers/events/risk": amdModule203,
"linced-enrolments/serializers/events/template": amdModule204,
"linced-enrolments/serializers/goals/badge": amdModule205,
"linced-enrolments/serializers/goals/base": amdModule206,
"linced-enrolments/serializers/goals/category": amdModule207,
"linced-enrolments/serializers/goals/goal": amdModule208,
"linced-enrolments/serializers/goals/state": amdModule209,
"linced-enrolments/serializers/goals/subcategory": amdModule210,
"linced-enrolments/serializers/goals/subject": amdModule211,
"linced-enrolments/serializers/media": amdModule212,
"linced-enrolments/serializers/milestones/base": amdModule213,
"linced-enrolments/serializers/milestones/expectation": amdModule214,
"linced-enrolments/serializers/milestones/level": amdModule215,
"linced-enrolments/serializers/milestones/milestone-set": amdModule216,
"linced-enrolments/serializers/milestones/milestone": amdModule217,
"linced-enrolments/serializers/milestones/progression": amdModule218,
"linced-enrolments/serializers/person": amdModule219,
"linced-enrolments/serializers/posts/attendancenote": amdModule220,
"linced-enrolments/serializers/posts/base": amdModule221,
"linced-enrolments/serializers/posts/comment": amdModule222,
"linced-enrolments/serializers/posts/feed-entry": amdModule223,
"linced-enrolments/serializers/posts/globalnotice": amdModule224,
"linced-enrolments/serializers/posts/page-set": amdModule225,
"linced-enrolments/serializers/posts/page": amdModule226,
"linced-enrolments/serializers/posts/post-template": amdModule227,
"linced-enrolments/serializers/posts/post": amdModule228,
"linced-enrolments/serializers/posts/reaction": amdModule229,
"linced-enrolments/serializers/posts/tag-category": amdModule230,
"linced-enrolments/serializers/posts/tag": amdModule231,
"linced-enrolments/serializers/reports/base": amdModule232,
"linced-enrolments/serializers/reports/report-feedback": amdModule233,
"linced-enrolments/serializers/reports/report-template-section": amdModule234,
"linced-enrolments/serializers/reports/report-template": amdModule235,
"linced-enrolments/serializers/reports/rubric-criteria": amdModule236,
"linced-enrolments/serializers/reports/rubric-element": amdModule237,
"linced-enrolments/serializers/reports/rubric-family": amdModule238,
"linced-enrolments/serializers/reports/rubric-state": amdModule239,
"linced-enrolments/serializers/reports/rubric": amdModule240,
"linced-enrolments/serializers/reports/student-report-section": amdModule241,
"linced-enrolments/serializers/reports/student-report": amdModule242,
"linced-enrolments/serializers/school-options/field": amdModule243,
"linced-enrolments/serializers/school-options/group": amdModule244,
"linced-enrolments/serializers/school-options/heading": amdModule245,
"linced-enrolments/serializers/school": amdModule246,
"linced-enrolments/serializers/sif/au/base": amdModule247,
"linced-enrolments/serializers/sif/au/connection": amdModule248,
"linced-enrolments/serializers/sif/au/zone": amdModule249,
"linced-enrolments/serializers/surveys/base": amdModule250,
"linced-enrolments/serializers/surveys/response": amdModule251,
"linced-enrolments/serializers/surveys/survey": amdModule252,
"linced-enrolments/serializers/timetable/base": amdModule253,
"linced-enrolments/serializers/timetable/period": amdModule254,
"linced-enrolments/serializers/timetable/structure": amdModule255,
"linced-enrolments/serializers/user": amdModule256,
"linced-enrolments/serializers/wonde/connection": amdModule257,
"linced-enrolments/serializers/wonde/school": amdModule258,
"linced-enrolments/services/colours": amdModule259,
"linced-enrolments/services/dates": amdModule260,
"linced-enrolments/services/environment": amdModule261,
"linced-enrolments/services/faro": amdModule262,
"linced-enrolments/services/fetch": amdModule263,
"linced-enrolments/services/field-options": amdModule264,
"linced-enrolments/services/google-drive": amdModule265,
"linced-enrolments/services/group-years": amdModule266,
"linced-enrolments/services/hero-api-auth": amdModule267,
"linced-enrolments/services/hero-api-bookings-allocations": amdModule268,
"linced-enrolments/services/hero-api-bookings": amdModule269,
"linced-enrolments/services/hero-api-comments": amdModule270,
"linced-enrolments/services/hero-api-goals": amdModule271,
"linced-enrolments/services/hero-api-people": amdModule272,
"linced-enrolments/services/hero-api": amdModule273,
"linced-enrolments/services/logging": amdModule274,
"linced-enrolments/services/media": amdModule275,
"linced-enrolments/services/notifications": amdModule276,
"linced-enrolments/services/options": amdModule277,
"linced-enrolments/services/permissions": amdModule278,
"linced-enrolments/services/person-options": amdModule279,
"linced-enrolments/services/policy-acceptance": amdModule280,
"linced-enrolments/services/print": amdModule281,
"linced-enrolments/services/push-notifications": amdModule282,
"linced-enrolments/services/roles": amdModule283,
"linced-enrolments/services/session": amdModule284,
"linced-enrolments/services/strings": amdModule285,
"linced-enrolments/services/tax": amdModule286,
"linced-enrolments/services/terms": amdModule287,
"linced-enrolments/services/toaster": amdModule288,
"linced-enrolments/services/uppy": amdModule289,
"linced-enrolments/transforms/json": amdModule290,
"linced-enrolments/utils/auditing": amdModule291,
"linced-enrolments/utils/chunk": amdModule292,
"linced-enrolments/utils/colour": amdModule293,
"linced-enrolments/utils/d3-tip": amdModule294,
"linced-enrolments/utils/dynamic-field-types": amdModule295,
"linced-enrolments/utils/fields": amdModule296,
"linced-enrolments/utils/filtering": amdModule297,
"linced-enrolments/utils/grades": amdModule298,
"linced-enrolments/utils/long-tasks": amdModule299,
"linced-enrolments/utils/map-with-concurrency": amdModule300,
"linced-enrolments/utils/oauth2": amdModule301,
"linced-enrolments/utils/options": amdModule302,
"linced-enrolments/utils/platform": amdModule303,
"linced-enrolments/utils/post-templates": amdModule304,
"linced-enrolments/utils/progressions": amdModule305,
"linced-enrolments/utils/pronouns": amdModule306,
"linced-enrolments/utils/reports": amdModule307,
"linced-enrolments/utils/school-date": amdModule308,
"linced-enrolments/utils/snapshots": amdModule309,
"linced-enrolments/utils/stationery": amdModule310,
"linced-enrolments/utils/strings": amdModule311,
"linced-enrolments/utils/table": amdModule312,
"linced-enrolments/utils/tags": amdModule313,
"linced-enrolments/utils/tinymce": amdModule314,
"linced-enrolments/utils/topic-steps": amdModule315,
"linced-enrolments/services/page-title": amdModule316,
"linced-enrolments/services/drag-sort": amdModule317,
"linced-enrolments/templates/apply-complete": amdModule318,
"linced-enrolments/controllers/apply-complete": amdModule319,
"linced-enrolments/routes/apply-complete": amdModule320,
"linced-enrolments/templates/apply": amdModule321,
"linced-enrolments/controllers/apply": amdModule322,
"linced-enrolments/routes/apply": amdModule323,
"linced-enrolments/templates/error": amdModule324,
"linced-enrolments/controllers/error": amdModule325,
"linced-enrolments/routes/base": amdModule326,
"linced-enrolments/templates/school-not-found": amdModule327,
"linced-enrolments/routes/school-not-found": amdModule328,
"linced-enrolments/templates/application": amdModule329,
"linced-enrolments/templates/loading": amdModule330,
"linced-enrolments/templates/logged-out": amdModule331,
"linced-enrolments/controllers/logged-out": amdModule332,
"linced-enrolments/routes/logged-out": amdModule333,
"linced-enrolments/templates/login-failed": amdModule334,
"linced-enrolments/controllers/login-failed": amdModule335,
"linced-enrolments/routes/login-failed": amdModule336,
"linced-enrolments/templates/school-switching": amdModule337,
"linced-enrolments/controllers/school-switching": amdModule338,
"linced-enrolments/routes/school-switching": amdModule339,
"linced-enrolments/templates/callback": amdModule340,
"linced-enrolments/routes/callback": amdModule341,
"linced-enrolments/routes/login": amdModule342,
"linced-enrolments/templates/logout": amdModule343,
"linced-enrolments/routes/logout": amdModule344,
"linced-enrolments/routes/springboard": amdModule345,
"linced-enrolments/routes/startup": amdModule346,
"linced-enrolments/templates/not-found": amdModule347,
  },
  exportFastbootModules
);
